import React, { FC, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'
import { Element, GraphQLImage } from '@components'
import { pickFromDefaults } from './pickFromDefaults'

import { UserBackgroundPhoto_user$key } from '@components/User/__generated__/UserBackgroundPhoto_user.graphql'

const DEFAULT_BACKGROUNDS = [
  'radial-gradient(114% 86.44% at 93.08% -9.01%, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(65.03% 49.37% at 67.2% -1.1%, rgba(97, 227, 255, 0.7) 0%, rgba(97, 227, 255, 0) 100%), radial-gradient(73.71% 91.32% at 0% 100%, rgba(228, 213, 79, 0.7) 0%, rgba(228, 79, 79, 0) 100%), radial-gradient(62.83% 107.44% at 97.15% 97.09%, rgba(228, 79, 79, 0.7) 0%, rgba(228, 79, 79, 0) 100%), radial-gradient(99.64% 75.06% at 8.54% 18.33%, rgba(85, 51, 235, 0.7) 0%, rgba(85, 51, 235, 0) 100%), #E5ADFF',
  'radial-gradient(114% 86.44% at 93.08% -9.01%, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(62.83% 107.44% at 97.15% 97.09%, rgba(228, 79, 79, 0.7) 0%, rgba(228, 79, 79, 0) 100%), radial-gradient(99.64% 75.06% at 8.54% 18.33%, rgba(85, 51, 235, 0.7) 0%, rgba(85, 51, 235, 0) 100%), linear-gradient(0deg, #E5ADFF, #E5ADFF), radial-gradient(114% 86.44% at 93.08% -9.01%, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(65.03% 49.37% at 67.2% -1.1%, rgba(97, 227, 255, 0.7) 0%, rgba(97, 227, 255, 0) 100%), radial-gradient(73.71% 91.32% at 0% 100%, rgba(228, 213, 79, 0.7) 0%, rgba(228, 79, 79, 0) 100%)',
]

export const UserBackgroundPhoto: FC<{
  user: UserBackgroundPhoto_user$key
}> = ({ user }) => {
  const { backgroundPhoto, rowId } = useFragment(
    graphql`
      fragment UserBackgroundPhoto_user on User {
        rowId
        backgroundPhoto {
          ...GraphQLImage_image
        }
      }
    `,
    user
  )

  return backgroundPhoto ? (
    <GraphQLImage
      component='ActorCardBackgroundPhoto'
      image={backgroundPhoto}
      maxWidth='max'
      maxHeight={30}
      focus='auto'
    />
  ) : (
    <UserBackgroundFallback rowId={rowId} />
  )
}

const UserBackgroundFallback: FC<{ rowId?: string }> = ({ rowId }) => {
  const background = useMemo(
    () => pickFromDefaults(rowId, DEFAULT_BACKGROUNDS),
    [rowId]
  )
  return (
    <Element
      component='ActorCardBackgroundPhoto'
      tokens={{
        height: 30,
        width: '100%',
        background,
      }}
    />
  )
}
